import styles from "./style.module.scss";
import { Link } from "react-router-dom";

export const BasicSection = () => {
  return (
    <section className={styles.container}>
      <div className={styles.innerBox}>
        <h3>information -詳細情報-</h3>
        <ul>
          <li>
            <p className={styles.head}>施設名</p>
            <p className={styles.body}>石巻マリンヴィレッジ</p>
          </li>
          <li>
            <p className={styles.head}>住所</p>
            <p className={styles.body}>宮城県石巻市新館3丁目4-18</p>
          </li>
          <li>
            <p className={styles.head}>アクセス</p>
            <p className={styles.body}>
              車の場合：三陸自動車道石巻港ICより約6分、JR石巻駅より約10分
              <br />
              公共交通機関の場合：JR石巻駅でミヤコーバス免許センター線に乗車→大街道新橋で下車し徒歩約10分
            </p>
          </li>
          <li>
            <p className={styles.head}>宿泊形式</p>
            <p className={styles.body}>一棟団体貸切</p>
          </li>
          <li>
            <p className={styles.head}>宿泊可能棟数</p>
            <p className={styles.body}>2棟（SANRIKU棟、JIGUNOMAKI棟）</p>
          </li>
          <li>
            <p className={styles.head}>宿泊可能人数</p>
            <p className={styles.body}>各棟4人まで</p>
          </li>
          <li>
            <p className={styles.head}>駐車可能台数</p>
            <p className={styles.body}>2台（各棟1台）</p>
          </li>
          <li>
            <p className={styles.head}>チェックイン時間</p>
            <p className={styles.body}>チェックイン：15:00〜</p>
          </li>
          <li>
            <p className={styles.head}>チェックアウト時間</p>
            <p className={styles.body}>チェックアウト：〜 10:00</p>
          </li>
          <li>
            <p className={styles.head}>チェックイン方法</p>
            <p className={styles.body} style={{ textAlign: "center" }}>
              無人チェックイン
              <br />
              （チェックイン方法は予約完了後にメールでご連絡いたします）
            </p>
          </li>
          <li>
            <p className={styles.head}>チェックアウト方法</p>
            <p className={styles.body} style={{ textAlign: "center" }}>
              無人チェックアウト
              <br />
              （チェックアウト方法は予約完了後にメールでご連絡いたします）
            </p>
          </li>
          <li>
            <p className={styles.head}>予約方法</p>
            <p className={styles.body}>
              <Link to="/reservation">こちら</Link>から予約可能
            </p>
          </li>
        </ul>
        <p className={styles.ulInfo}>
          ※詳しいアクセス情報については
          <Link to="/access">こちら</Link>をご確認ください。
        </p>
      </div>
    </section>
  );
};
